import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Dropdown, Icon, Row, Col, Button } from 'antd'
import LangContext, { i18n } from 'modules/shared/context/langContext'
import { checkPermissions } from '../../../lib/helper'

class CustomMenuItem extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  getPermissionElement = (permissions, matching_name) => {
    let permission_data = this.getPermissionData(permissions, matching_name)

    if (permission_data.length > 0) {
      let permission_url = permission_data[0].url || ''
      let permission_name = permission_data[0].name || ''
      let permission_name_en = permission_data[0].name_en || ''
      let url_type = permission_data[0].url_type || 1

      let permission_display = ''
      if (this.props.language == 'en') {
        permission_display = permission_name_en
      } else {
        permission_display = permission_name
      }
      if (permission_url && permission_display) {
        if (matching_name == 'deliveryDashboard') {
          // แดชบอร์ดขนส่งวัตถุดิบ
          return (
            <Row>
              <Link
                to={permission_url}
                style={{ color: 'rgba(0, 0, 0, 0.65)' }}
              >
                <Col span={14}>
                  <span className='nav-text'>{permission_display}</span>
                </Col>
                <Col span={10} align='right'>
                  {/* ปุ่มสั่งวัตถุดิบ */}
                  {checkPermissions(
                    this.props.profile.permissions,
                    'requestMaterial',
                    'can_add'
                  ) && (
                    <Link
                      to='/request-material/multiple-create'
                      style={{ color: 'rgba(0, 0, 0, 0.65)' }}
                    >
                      <Button
                        type='default'
                        size='small'
                        style={{ fontSize: '12px', padding: '0px 3px' }}
                      >
                        <span>
                          <Icon
                            type='plus'
                            style={{ marginRight: '3px', fontSize: '12px' }}
                          />
                        </span>
                        <span className='nav-text'>
                          {i18n[this.props.language].o.orderMaterial}
                        </span>
                      </Button>
                    </Link>
                  )}
                </Col>
              </Link>
            </Row>
          )
        } else if (matching_name == 'commandCenterDashboard') {
          return (
            <Link to={permission_url} target='_blank'>
              <span className='nav-text'>{permission_display}</span>
            </Link>
          )
        } else if (url_type == 2) {
          // External URL
          return (
            <a href={permission_url} target='_blank' rel='noopener noreferrer'>
              <span className='nav-text'>{permission_display}</span>
            </a>
          )
        }

        return (
          <Link to={permission_url}>
            <span className='nav-text'>{permission_display}</span>
          </Link>
        )
      } else {
        return null
      }
    }

    return null
  }

  getPermissionData = (permissions, matching_name) => {
    let data = permissions.filter(function(ele) {
      return ele.matching_name == matching_name && ele.can_view == 1
    })

    return data
  }

  render() {
    const {
      matching_name,
      permissions,

      children,
    } = this.props

    return (
      <>{this.getPermissionElement(permissions, matching_name) || children}</>
    )
  }
}

export default connect(
  ({ auth, auth: { profile }, ui: { language } }) => ({
    auth,
    profile,
    language,
  }),
  {}
)(CustomMenuItem)
